<prism-modal
  title="{{ dialogTitle }}"
  titleIconType="submit"
  blurBackground="true"
  [opened]="showDialog"
  [actions]="dialogActions"
  (cancel)="closeDialog()"
>
  <div class="mt-1 mb-2">
    <div class="instructions">
      <p>Acceptable file types: {{ fileRestrictions.allowedExtensions.join(', ') | uppercase }}</p>
    </div>
    <prism-upload
      deleteStrategy="delete"
      [fileRestrictions]="fileRestrictions"
      [allowMultiple]="false"
      [hideActions]="true"
      (selectedFile)="selectedFile($event)"
      (deletedFile)="deletedFile()"
    ></prism-upload>
    <ng-container *ngIf="showErrorMessage">
      <div class="errorMessage">
        <p>There was an error during this operation. Please try again later.</p>
      </div>
      <div *ngIf="!showDetailedError">
        <a (click)="showDetails()">show details <span class="k-icon k-font-icon k-i-arrow-down"></span></a>
      </div>
      <div *ngIf="showDetailedError">
        <a (click)="showDetails()">hide details <span class="k-icon k-font-icon k-i-arrow-up"></span></a>
      </div>
      <div *ngIf="showDetailedError">
        <p>{{ detailedErrorMessage }}</p>
      </div>
    </ng-container>
  </div>
</prism-modal>
